// Force Urbania Routes Data
// Contains vehicle options with pricing for Force Urbania bookings

export const forceUrbaniaRoutes = {
  // Amritsar Routes (12 routes)
  'amritsar-to-agra': {
    from: 'Amritsar',
    to: 'Agra',
    fareStart: 61200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12dbd1175-1766710123600.png",
    alt: 'Taj Mahal Agra with beautiful Mughal architecture and gardens',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 61200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Agra trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 65300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Agra trip'
    }]

  },
  'amritsar-to-amarnath': {
    from: 'Amritsar',
    to: 'Amarnath',
    fareStart: 54000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_131683cf6-1768520248091.png",
    alt: 'Amarnath cave temple with ice shivling in Himalayan mountains',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 54000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amarnath trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 57618,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amarnath trip'
    }]

  },
  'amritsar-to-ayodhya': {
    from: 'Amritsar',
    to: 'Ayodhya',
    fareStart: 108000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8992d70-1768522883552.png",
    alt: 'Ayodhya Ram Mandir with traditional Hindu temple architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 108000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Ayodhya trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 115236,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Ayodhya trip'
    }]

  },
  'amritsar-to-badrinath-kedarnath': {
    from: 'Amritsar',
    to: 'Badrinath Kedarnath',
    fareStart: 111600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16cb23ee6-1768229300908.png",
    alt: 'Badrinath and Kedarnath temples in Himalayan mountains with pilgrims',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 111600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Badrinath Kedarnath trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 119077,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Badrinath Kedarnath trip'
    }]

  },
  'amritsar-to-char-dham': {
    from: 'Amritsar',
    to: 'Char Dham',
    fareStart: 111600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c40fb940-1765108447477.png",
    alt: 'Char Dham pilgrimage sites with Himalayan mountain backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 111600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Char Dham trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 119077,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Char Dham trip'
    }]

  },
  'amritsar-to-dalhousie': {
    from: 'Amritsar',
    to: 'Dalhousie',
    fareStart: 32400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1170435a7-1768522886302.png",
    alt: 'Dalhousie hill station with colonial architecture and pine forests',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dalhousie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 34571,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dalhousie trip'
    }]

  },
  'amritsar-to-dharamshala': {
    from: 'Amritsar',
    to: 'Dharamshala',
    fareStart: 39600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689343075610-aa77066f3df5',
    alt: 'Dharamshala mountain town with Tibetan monasteries and Himalayan backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 39600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dharamshala trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 42253,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d461a4d4-1768082329835.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dharamshala trip'
    }]

  },
  'amritsar-to-govind-ghat': {
    from: 'Amritsar',
    to: 'Govind Ghat',
    fareStart: 108000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a2286436-1768524311480.png",
    alt: 'Govind Ghat gateway to Valley of Flowers with mountain scenery',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 108000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Govind Ghat trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 115236,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Govind Ghat trip'
    }]

  },
  'amritsar-to-haridwar': {
    from: 'Amritsar',
    to: 'Haridwar',
    fareStart: 46800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be9d0262-1768145557671.png",
    alt: 'Haridwar Ganga Aarti with devotees at Har Ki Pauri ghat',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 46800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Haridwar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 49936,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Haridwar trip'
    }]

  },
  'amritsar-to-jaipur': {
    from: 'Amritsar',
    to: 'Jaipur',
    fareStart: 61200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://images.unsplash.com/photo-1612105301362-0d4900e364fa",
    alt: 'Jaipur Pink City with Hawa Mahal and Rajasthani architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 61200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Jaipur trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 65300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Jaipur trip'
    }]

  },
  'amritsar-to-jim-corbett': {
    from: 'Amritsar',
    to: 'Jim Corbett',
    fareStart: 61200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_175ba6e0a-1768517531385.png",
    alt: 'Jim Corbett National Park with Bengal tiger and lush forest landscape',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 61200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Jim Corbett trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 65300,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Jim Corbett trip'
    }]

  },
  'amritsar-to-kasauli': {
    from: 'Amritsar',
    to: 'Kasauli',
    fareStart: 46800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Kasauli hill station with colonial buildings and pine forest views',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 46800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Kasauli trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 49936,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Kasauli trip'
    }]

  },

  // Delhi Routes (12 routes)
  'delhi-to-manali': {
    from: 'Delhi',
    to: 'Manali',
    fareStart: 54000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://images.unsplash.com/photo-1669342623205-470f4ae62681',
    alt: 'Scenic Manali valley with snow-capped mountains and lush green landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 54000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van with premium interiors'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 57618,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van with maximum seating capacity'
    }]
  },
  'delhi-to-shimla': {
    from: 'Delhi',
    to: 'Shimla',
    fareStart: 46800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Beautiful Shimla hill station with colonial architecture and pine trees',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 46800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Shimla trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 49936,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Shimla trip'
    }]
  },
  'delhi-to-dharamshala': {
    from: 'Delhi',
    to: 'Dharamshala',
    fareStart: 57600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://images.unsplash.com/photo-1689343075610-aa77066f3df5',
    alt: 'Dharamshala mountain town with Tibetan monasteries and Himalayan backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 57600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dharamshala trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 61459,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dharamshala trip'
    }]
  },
  'delhi-to-amritsar': {
    from: 'Delhi',
    to: 'Amritsar',
    fareStart: 36000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: "https://images.unsplash.com/photo-1689141083335-fc7aa682b166",
    alt: 'Golden Temple Amritsar illuminated at night with reflection in sacred pool',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amritsar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 38412,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amritsar trip'
    }]
  },
  'delhi-to-dalhousie': {
    from: 'Delhi',
    to: 'Dalhousie',
    fareStart: 57600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Dalhousie hill station with colonial architecture and pine forests',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 57600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dalhousie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 61459,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dalhousie trip'
    }]
  },
  'delhi-to-mussoorie': {
    from: 'Delhi',
    to: 'Mussoorie',
    fareStart: 36000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_193fd62b8-1768082667331.png',
    alt: 'Mussoorie queen of hills with scenic mountain views and waterfalls',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 36000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Mussoorie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 38412,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Mussoorie trip'
    }]
  },
  'delhi-to-himachal-pradesh': {
    from: 'Delhi',
    to: 'Himachal Pradesh',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b86084a9-1766126936378.png',
    alt: 'Himachal Pradesh scenic mountain landscapes with valleys and peaks',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Himachal Pradesh trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Himachal Pradesh trip'
    }]
  },
  'delhi-to-khatu-shyam': {
    from: 'Delhi',
    to: 'Khatu Shyam',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_106000179-1768521060053.png',
    alt: 'Khatu Shyam temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Khatu Shyam trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26888,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Khatu Shyam trip'
    }]
  },
  'delhi-to-salasar-balaji': {
    from: 'Delhi',
    to: 'Salasar Balaji',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_170ee1058-1768521060390.png',
    alt: 'Salasar Balaji temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Salasar Balaji trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26888,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Salasar Balaji trip'
    }]
  },
  'delhi-to-kasol': {
    from: 'Delhi',
    to: 'Kasol',
    fareStart: 54000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1436f99bf-1768121154045.png",
    alt: 'Kasol valley with Parvati river and mountain landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 54000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Kasol trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 57618,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Kasol trip'
    }]
  },
  'delhi-to-mathura': {
    from: 'Delhi',
    to: 'Mathura',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_138362f7c-1768521060051.png',
    alt: 'Mathura temples with Krishna devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Mathura trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Mathura trip'
    }]
  },
  'delhi-to-vrindavan': {
    from: 'Delhi',
    to: 'Vrindavan',
    fareStart: 16560,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days', '7 Days', '8 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_17d717d4f-1768521060814.png',
    alt: 'Vrindavan temples with Krishna devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 16560,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Vrindavan trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 17669,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Vrindavan trip'
    }]
  },

  // Chandigarh Routes (12 routes)
  'chandigarh-to-manali': {
    from: 'Chandigarh',
    to: 'Manali',
    fareStart: 32400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1669342623205-470f4ae62681',
    alt: 'Scenic Manali valley with snow-capped mountains and lush green landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Manali trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 34571,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Manali trip'
    }]

  },
  'chandigarh-to-shimla': {
    from: 'Chandigarh',
    to: 'Shimla',
    fareStart: 12960,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Beautiful Shimla hill station with colonial architecture and pine trees',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 12960,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Shimla trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 13828,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Shimla trip'
    }]

  },
  'chandigarh-to-dharamshala': {
    from: 'Chandigarh',
    to: 'Dharamshala',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689343075610-aa77066f3df5',
    alt: 'Dharamshala mountain town with Tibetan monasteries and Himalayan backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dharamshala trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dharamshala trip'
    }]

  },
  'chandigarh-to-amritsar': {
    from: 'Chandigarh',
    to: 'Amritsar',
    fareStart: 18720,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1717310686769-5157bcefe109",
    alt: 'Golden Temple Amritsar illuminated at night with reflection in sacred pool',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18720,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amritsar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19974,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amritsar trip'
    }]

  },
  'chandigarh-to-dalhousie': {
    from: 'Chandigarh',
    to: 'Dalhousie',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Dalhousie hill station with colonial architecture and pine forests',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dalhousie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dalhousie trip'
    }]

  },
  'chandigarh-to-mussoorie': {
    from: 'Chandigarh',
    to: 'Mussoorie',
    fareStart: 28800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_193fd62b8-1768082667331.png',
    alt: 'Mussoorie queen of hills with scenic mountain views and waterfalls',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 28800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Mussoorie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30730,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Mussoorie trip'
    }]

  },
  'chandigarh-to-himachal-pradesh': {
    from: 'Chandigarh',
    to: 'Himachal Pradesh',
    fareStart: 21600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b86084a9-1766126936378.png',
    alt: 'Himachal Pradesh scenic mountain landscapes with valleys and peaks',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 21600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Himachal Pradesh trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 23047,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Himachal Pradesh trip'
    }]

  },
  'chandigarh-to-khatu-shyam': {
    from: 'Chandigarh',
    to: 'Khatu Shyam',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_106000179-1768521060053.png',
    alt: 'Khatu Shyam temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Khatu Shyam trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Khatu Shyam trip'
    }]

  },
  'chandigarh-to-salasar-balaji': {
    from: 'Chandigarh',
    to: 'Salasar Balaji',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_170ee1058-1768521060390.png',
    alt: 'Salasar Balaji temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Salasar Balaji trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Salasar Balaji trip'
    }]

  },
  'chandigarh-to-kasol': {
    from: 'Chandigarh',
    to: 'Kasol',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1463974483158-d2746735431c",
    alt: 'Kasol valley with Parvati river and scenic mountain landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Kasol trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Kasol trip'
    }]

  },
  'chandigarh-to-delhi-airport': {
    from: 'Chandigarh',
    to: 'Delhi Airport',
    fareStart: 18720,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1436f99bf-1768121154045.png",
    alt: 'Delhi Airport terminal with modern architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18720,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Delhi Airport trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19974,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Delhi Airport trip'
    }]

  },
  'chandigarh-to-delhi': {
    from: 'Chandigarh',
    to: 'Delhi',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Delhi India Gate with beautiful architecture and gardens',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Delhi trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Delhi trip'
    }]

  },

  // Mohali Routes (12 routes)
  'mohali-to-manali': {
    from: 'Mohali',
    to: 'Manali',
    fareStart: 32400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1669342623205-470f4ae62681',
    alt: 'Scenic Manali valley with snow-capped mountains and lush green landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 32400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Manali trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 34571,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Manali trip'
    }]

  },
  'mohali-to-shimla': {
    from: 'Mohali',
    to: 'Shimla',
    fareStart: 12960,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1669635482695-e4acf7c017ad",
    alt: 'Beautiful Shimla hill station with colonial architecture and pine trees',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 12960,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Shimla trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 13828,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Shimla trip'
    }]

  },
  'mohali-to-dharamshala': {
    from: 'Mohali',
    to: 'Dharamshala',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689343075610-aa77066f3df5',
    alt: 'Dharamshala mountain town with Tibetan monasteries and Himalayan backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dharamshala trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dharamshala trip'
    }]

  },
  'mohali-to-amritsar': {
    from: 'Mohali',
    to: 'Amritsar',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1689141083335-fc7aa682b166",
    alt: 'Golden Temple Amritsar illuminated at night with reflection in sacred pool',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amritsar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amritsar trip'
    }]

  },
  'mohali-to-dalhousie': {
    from: 'Mohali',
    to: 'Dalhousie',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Dalhousie hill station with colonial architecture and pine forests',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dalhousie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dalhousie trip'
    }]

  },
  'mohali-to-mussoorie': {
    from: 'Mohali',
    to: 'Mussoorie',
    fareStart: 28800,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_193fd62b8-1768082667331.png',
    alt: 'Mussoorie queen of hills with scenic mountain views and waterfalls',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 28800,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Mussoorie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 30730,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Mussoorie trip'
    }]

  },
  'mohali-to-himachal-pradesh': {
    from: 'Mohali',
    to: 'Himachal Pradesh',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_1b86084a9-1766126936378.png',
    alt: 'Himachal Pradesh scenic mountain landscapes with valleys and peaks',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Himachal Pradesh trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26888,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Himachal Pradesh trip'
    }]

  },
  'mohali-to-khatu-shyam': {
    from: 'Mohali',
    to: 'Khatu Shyam',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_106000179-1768521060053.png',
    alt: 'Khatu Shyam temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Khatu Shyam trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Khatu Shyam trip'
    }]

  },
  'mohali-to-salasar-balaji': {
    from: 'Mohali',
    to: 'Salasar Balaji',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://img.rocket.new/generatedImages/rocket_gen_img_170ee1058-1768521060390.png',
    alt: 'Salasar Balaji temple with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Salasar Balaji trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Salasar Balaji trip'
    }]

  },
  'mohali-to-kasol': {
    from: 'Mohali',
    to: 'Kasol',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1436f99bf-1768121154045.png",
    alt: 'Kasol valley with Parvati river and scenic mountain landscapes',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Kasol trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Kasol trip'
    }]

  },
  'mohali-to-delhi-airport': {
    from: 'Mohali',
    to: 'Delhi Airport',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1463974483158-d2746735431c",
    alt: 'Delhi Airport terminal with modern architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e968eef3-1767645976455.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Delhi Airport trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Delhi Airport trip'
    }]

  },
  'mohali-to-delhi': {
    from: 'Mohali',
    to: 'Delhi',
    fareStart: 17280,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://images.unsplash.com/photo-1669635482695-e4acf7c017ad",
    alt: 'Delhi India Gate with beautiful architecture and gardens',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 17280,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Delhi trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 18438,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Delhi trip'
    }]

  },

  // Patiala Routes (12 routes)
  'patiala-to-agra': {
    from: 'Patiala',
    to: 'Agra',
    fareStart: 39600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12dbd1175-1766710123600.png",
    alt: 'Taj Mahal Agra with beautiful Mughal architecture and gardens',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 39600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Agra trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 42253,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Agra trip'
    }]

  },
  'patiala-to-amarnath': {
    from: 'Patiala',
    to: 'Amarnath',
    fareStart: 57600,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_131683cf6-1768520248091.png",
    alt: 'Amarnath cave temple with ice shivling in Himalayan mountains',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 57600,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amarnath trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 61459,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amarnath trip'
    }]

  },
  'patiala-to-amritsar': {
    from: 'Patiala',
    to: 'Amritsar',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689141083335-fc7aa682b166',
    alt: 'Golden Temple Amritsar illuminated at night with reflection in sacred pool',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amritsar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amritsar trip'
    }]

  },
  'patiala-to-amritsar-sahib': {
    from: 'Patiala',
    to: 'Amritsar Sahib',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689141083335-fc7aa682b166',
    alt: 'Golden Temple Amritsar Sahib with devotees and religious architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Amritsar Sahib trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Amritsar Sahib trip'
    }]

  },
  'patiala-to-ayodhya': {
    from: 'Patiala',
    to: 'Ayodhya',
    fareStart: 86400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_145527d17-1768524310918.png",
    alt: 'Ayodhya Ram Mandir with beautiful temple architecture',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 86400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Ayodhya trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 92189,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Ayodhya trip'
    }]

  },
  'patiala-to-badrinath-kedarnath': {
    from: 'Patiala',
    to: 'Badrinath Kedarnath',
    fareStart: 90000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_16d2db56a-1768617098546.png",
    alt: 'Badrinath and Kedarnath temples in Himalayan mountains',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 90000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Badrinath Kedarnath trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 96030,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Badrinath Kedarnath trip'
    }]

  },
  'patiala-to-char-dham': {
    from: 'Patiala',
    to: 'Char Dham',
    fareStart: 90000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c40fb940-1765108447477.png",
    alt: 'Char Dham pilgrimage sites in Uttarakhand Himalayas',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 90000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Char Dham trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 96030,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Char Dham trip'
    }]

  },
  'patiala-to-dalhousie': {
    from: 'Patiala',
    to: 'Dalhousie',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12aa07745-1768517530322.png",
    alt: 'Dalhousie hill station with colonial architecture and pine forests',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dalhousie trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dalhousie trip'
    }]

  },
  'patiala-to-dharamshala': {
    from: 'Patiala',
    to: 'Dharamshala',
    fareStart: 43200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689343075610-aa77066f3df5',
    alt: 'Dharamshala mountain town with Tibetan monasteries and Himalayan backdrop',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 43200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Dharamshala trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 46094,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Dharamshala trip'
    }]

  },
  'patiala-to-golden-temple-amritsar': {
    from: 'Patiala',
    to: 'Golden Temple Amritsar',
    fareStart: 18000,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: 'https://images.unsplash.com/photo-1689141083335-fc7aa682b166',
    alt: 'Golden Temple Amritsar illuminated at night with reflection in sacred pool',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 18000,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Golden Temple Amritsar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 19206,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Golden Temple Amritsar trip'
    }]

  },
  'patiala-to-govind-ghat': {
    from: 'Patiala',
    to: 'Govind Ghat',
    fareStart: 86400,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['4 Days', '5 Days', '6 Days', '7 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a2286436-1768524311480.png",
    alt: 'Govind Ghat gateway to Valley of Flowers and Hemkund Sahib',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 86400,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Govind Ghat trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 92189,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_1364d5d99-1768517529483.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Govind Ghat trip'
    }]

  },
  'patiala-to-haridwar': {
    from: 'Patiala',
    to: 'Haridwar',
    fareStart: 25200,
    companyName: 'Advait Tour and Travels',
    phone: '+91-79986-66660',
    dayOptions: ['3 Days', '4 Days', '5 Days', '6 Days'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1be9d0262-1768145557671.png",
    alt: 'Haridwar Ganga Aarti with devotees at Har Ki Pauri ghat',
    vehicles: [
    {
      id: 1,
      name: 'Urbania',
      seats: 12,
      luggage: 9,
      price: 25200,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 12 seater luxury van for Haridwar trip'
    },
    {
      id: 2,
      name: 'Force Urbania',
      seats: 16,
      luggage: 16,
      price: 26888,
      image: "https://img.rocket.new/generatedImages/rocket_gen_img_18ecbb159-1768520248568.png",
      imageAlt: 'Force Urbania 16 seater luxury van for Haridwar trip'
    }]

  }
};